var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getNotifications()),function(alert,index){return _c('material-alert',{key:index,attrs:{"id":alert.id,"type":alert.type,"dismissible":alert.dismissible}},[_vm._v(" "+_vm._s(alert.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }